export const DEFAULT_FADE_DURATION = 200; // Default fade duration in milliseconds

const attributes = {
  animationTransitionType: {
    type: "string",
    default: "slide"
  },
  animationDirection: {
    type: "string",
    default: "vertical"
  },
  slideRevealType: {
    type: "string",
    default: "reveal"
  },
  fadeDuration: {
    type: "number",
    default: DEFAULT_FADE_DURATION
  },
};

export default attributes;
